import React from "react";
import { Routes, Route, Link, Outlet, useLocation } from 'react-router-dom';
import SignupForm from "../templates/signUpForrm/signUpForm";
import LoginForm from "../templates/loginForm/LoginForm";
import "./styles.css";
import {
  logo,
} from "../../assets/images";

const AuthPage = () => {
  const location = useLocation();
  return (
    <div className="auth-page">
      <div className="left-half">
        {/* keep this empty */}
      </div>
      <div className="right-half" style={{ flex: 1 }}>
        <div className="logo-box" style={{}}>
        <img
          src={logo}
          alt="Metro Home Services"
          className="logo-box"
        />
        </div>
        <Routes> 
          <Route path="/" element={<Outlet />}>
            <Route path="signup" element={<SignupForm />} />
            <Route path="login" element={<LoginForm />} />
          </Route>
        </Routes>
        <div className="login-link">
          {location.pathname === "/auth/signup" ? (
            <>
              Already have an account?{" "}
              <Link to="/auth/login">Log in</Link>
            </>
          ) : (
            <>
              Not registered? <Link to="/auth/signup">Sign up</Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
